import React, { useState, useEffect } from "react";
import { TextField, Popover, Box, Button, Typography } from "@mui/material";
import { TranslateW } from "../../../Utils/Languages/Translate";
import { Grey3 } from "../../../color_utils";
import { trakrefFontFamily, trakrefFontFamilySemiBold } from "../../../utils";

const RangeInput = ({
    label = "Select Range",
    onClose,
    startRange,
    endRange,
    disableEndRangeInput = false,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [range, setRange] = useState({ from: startRange || "0", to: endRange || "0" });

  const handleOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    if (onClose) {
      onClose(range.from, range.to);
    }
  };
  useEffect (() => {
    setRange({ from: startRange || "0", to: endRange || "0" });
  }, [startRange, endRange]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRange((prev) => ({ ...prev, [name]: value }));
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <TextField
        label={label}
        variant="standard"
        value={range.from && range.to ? `${range.from} - ${range.to}` : ""}
        onClick={handleOpen}
        InputProps={{
          readOnly: true,
          sx: {
            "&::placeholder": {
                color: Grey3,
                opacity: 1,
                fontSize: '16px',
            },
            fontFamily: trakrefFontFamily
          }
        }}
        InputLabelProps={{
          sx: {
              fontFamily: trakrefFontFamilySemiBold
          }
        }}
        fullWidth
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box p={2} width={300}>
          <Box display="flex" gap={2} flexDirection="row">
            <TextField
              label="From"
              name="from"
              type="number"
              value={range.from}
              onChange={handleChange}
              fullWidth
              onWheel={(e) => e.target.blur()}
            />
            <TextField
              label="To"
              name="to"
              type="number"
              value={range.to}
              onChange={handleChange}
              fullWidth
              InputProps={{
                readOnly: disableEndRangeInput,
              }}
              onWheel={(e) => e.target.blur()}
            />
          </Box>

          <div className="createFilter-apply">
              <div className="createFilter-apply-text" onClick={handleClose}>
                  {TranslateW("columnCustomizationApplyButton")}
              </div>
          </div>
        </Box>
      </Popover>
    </>
  );
};

export default RangeInput;